import { render, staticRenderFns } from "./RewardPeriodForm.vue?vue&type=template&id=5acfeffa"
import script from "./reward-period-form.ts?vue&type=script&lang=ts&external"
export * from "./reward-period-form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports